import React from "react";

// Catches lazy-chunk load failures (common after a new deploy invalidates old chunk
// filenames for users on a stale index) and recovers with a one-time auto-reload.
class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const msg = (error && error.message) || "";
    const isChunkError = /Loading chunk|ChunkLoadError|dynamically imported module|Loading CSS chunk/i.test(msg);
    if (isChunkError && !sessionStorage.getItem("chunk_reloaded")) {
      sessionStorage.setItem("chunk_reloaded", "1");
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4 px-6 text-center">
          <p className="text-foreground font-medium">A new version is available.</p>
          <p className="text-sm text-muted-foreground">Please reload to get the latest update.</p>
          <button
            onClick={() => { sessionStorage.removeItem("chunk_reloaded"); window.location.reload(); }}
            className="px-5 py-2.5 rounded-full bg-brand-500 hover:bg-brand-600 text-white text-sm font-medium transition-colors"
            data-testid="chunk-reload-btn"
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
